import { useEffect } from "react";
import { formatCurrency } from "../../../../../utils";
import { CardFrame } from "../../../../../common/components/card-frame/CardFrame";
import { useLazyGetBillHistoryQuery } from "../../../../../service/vending-service";
import { PostpaidBillHistoryCardSkeleton } from "./PostpaidBillHistoryCardSkeleton";
import styles from "./postpaid-bill-history-card.module.scss";
import { trackBillViewed } from "../../../../../services/business-analytics/energyManagementEvents";

const formatAmount = (value: number | null) => value != null ? formatCurrency(value) : "N/A";

export const PostpaidBillHistoryCard = () => {
	const [fetch, { data, isFetching, isUninitialized }] = useLazyGetBillHistoryQuery();

	useEffect(() => { fetch(); }, [fetch]);

	if (isFetching || isUninitialized) return <PostpaidBillHistoryCardSkeleton />;

	return (
		<CardFrame>
			<div className={styles.inner}>
				<div className={styles.row}>
					<div className={styles.col}>
						<span className={styles.label}>Last Billed Amount</span>
						<span className={styles.value}>{formatAmount(data?.lastBillAmount ?? null)}</span>
					</div>
					<div className={styles.colDivider} />
					<div className={styles.col}>
						<span className={styles.label}>Outstanding Balance</span>
						<span className={styles.value}>{formatAmount(data?.totalBalance ?? null)}</span>
					</div>
				</div>
				<div className={styles.divider} />
				<div className={styles.row}>
					<div className={styles.col}>
						<span className={styles.label}>Last Payment</span>
						<span className={styles.value}>{formatAmount(data?.lastPaymentAmount ?? null)}</span>
					</div>
					{data?.currentBillLink ? (
						<a
							href={data.currentBillLink}
							target="_blank"
							rel="noopener noreferrer"
							className={styles.viewBillButton}
							// The bill history response carries no bill id, only its link.
							onClick={() => trackBillViewed("postpaid")}
						>
							View Bill
						</a>
					) : (
						<button disabled className={`${styles.viewBillButton} ${styles.viewBillButtonDisabled}`}>
							View Bill
						</button>
					)}
				</div>
			</div>
		</CardFrame>
	);
};
